import { gql } from "@apollo/client";

export const GetAgreement = gql`
  query GetAgreement($id: String!) {
    agreementOne(id: $id) {
      isAutoRenew
      isMembership
      isGeneric
      isOrg
      locations {
        id
        name
      }
      name
      Unit
      termValue
      paymentFrequency
      draftMode
      draftValue
      isGroup
      scalingPrice
      groupPricingType
      limit
      additionalPolicies {
        id
        name
      }
      description
      postponeUntil
      recurringCharges {
        id
        cost
        name
        isTaxable
        isPostTax
        taxRates {
          id
          organizationTaxRate {
            name
          }
        }
        categoryOption {
          id
          name
        }
      }
      initialCharges {
        id
        cost
        isTaxable
        isPostTax
        taxRates {
          id
          organizationTaxRate {
            name
          }
        }
        revenue {
          id
          name
        }
        fee {
          id
          name
        }
        isDiscountable
      }
      initialAllotments {
        id
        name
        credits
      }
      recurringAllotments {
        id
        name
        credits
      }
      accessPeriods {
        id
        location {
          id
          name
        }
        start
        end
      }
    }
  }
`;

export const GetAgreementMany = gql`
  query GetAgreementMany($locationIds: [GenericConnectInput!]) {
    agreementMany(locationIds: $locationIds) {
      id
      isAutoRenew
      isMembership
      isGeneric
      isOrg
      name
      Unit
      termValue
      additionalPolicies {
        id
        name
      }
      description
      postponeUntil
      recurringCharges {
        id
        cost
        categoryOption {
          id
          name
        }
      }
      initialCharges {
        id
        cost
        revenue {
          id
          name
        }
        fee {
          id
          name
        }
        isDiscountable
      }
      initialAllotments {
        id
        name
        credits
      }
      recurringAllotments {
        id
        name
        credits
      }
      paymentFrequency
      groupPricingType
      isGroup
      limit
      scalingPrice
    }
  }
`;

export const GetAgreementPage = gql`
  query GetAgreementPage(
    $pagination: PaginationInput!
    $locationIds: [GenericConnectInput!]
  ) {
    agreementPage(pagination: $pagination, locationIds: $locationIds) {
      items {
        id
        viid
        version
        isMembership
        isAutoRenew
        isGeneric
        isOrg
        termValue
        Unit
        name
        isActive
      }
      totalRows
    }
  }
`;

export const GetAgreementNames = gql`
  query GetAgreementNames($locationIds: [GenericConnectInput!]) {
    agreementMany(locationIds: $locationIds) {
      id
      name
    }
  }
`;
